import {
  EachWorkdeskTicketI,
  EachSortBy,
  LoadWorkdeskTicketsParams,
} from 'store/models/workdesk-tickets';

const siTicketFilter = {
  SI: (ticket) => ticket.si,
  NON_SI: (ticket) => !ticket.si,
};
const ticketMatchedSi = (
  ticket: EachWorkdeskTicketI,
  ticketType: string,
) => {
  return siTicketFilter[ticketType](ticket);
};

const ticketMatchedInboxes = (
  ticket: EachWorkdeskTicketI,
  inboxes: string[],
) => {
  return inboxes.includes(ticket.inboxAddress.toLowerCase());
};

const matchedExactInboxes = (
  inboxesA: string[],
  inboxesB: string[],
) => {
  return (
    inboxesA.length === inboxesB.length &&
    inboxesA.every((a) => inboxesB.includes(a))
  );
};

const matchedAnyInboxes = (
  inboxesA: string[],
  inboxesB: string[],
) => {
  return inboxesA.some((inbox) => inboxesB.includes(inbox));
};

const matchedExactSortByArray = (
  sortByA: EachSortBy[],
  sortByB: EachSortBy[],
) => {
  return (
    sortByA.length === sortByB.length &&
    sortByA.every((sb, i) => matchedExactEachSortBy(sb, sortByB[i]))
  );
};

const matchedExactEachSortBy = (
  eSortByA: EachSortBy,
  eSortByB: EachSortBy,
): boolean => {
  return (
    eSortByA.field === eSortByB.field && eSortByA.dir === eSortByB.dir
  );
};

const ticketMatchedStatus = (
  ticket: EachWorkdeskTicketI,
  status: string,
) => {
  return ticket.status === status;
};

const matchLoadParams = (
  loadParams: LoadWorkdeskTicketsParams,
  loadParamsToMatch: LoadWorkdeskTicketsParams,
) => {
  const isStatus = loadParams.status === loadParamsToMatch.status;
  if (!isStatus) return false;
  const isTicketType =
    loadParams.ticketType === loadParamsToMatch.ticketType;
  if (!isTicketType) return false;
  const isExactInboxes = matchedExactInboxes(
    loadParams.inboxes,
    loadParamsToMatch.inboxes,
  );
  if (!isExactInboxes) return false;
  const isSortByArray = matchedExactSortByArray(
    loadParams.sortBy,
    loadParamsToMatch.sortBy,
  );
  return isSortByArray;
};
const MatchHelper = {
  ticketMatchedSi,
  ticketMatchedInboxes,
  matchedExactInboxes,
  matchedExactSortByArray,
  matchedExactEachSortBy,
  ticketMatchedStatus,
  matchedAnyInboxes,
  matchLoadParams,
};
export default MatchHelper;
